module.exports = __webpack_public_path__ + "img/1.00759f26.png";